import { format, getWeek } from "date-fns"

export const getUrlParams = () => {
    const url = window.location.href.split('?')[1]
    const urlParams = new URLSearchParams(url)
    const paramsObj = Object.fromEntries(urlParams)
    return paramsObj
}

export const getFirebaseDocs = snapshot => {
    var data = []
    for (let row of snapshot.docs) {
        data.push({ id: row.id, ...row.data() })
    }
    return data
}

export const removeTrailingSlash = social => {
    if (social[social.length - 1] === '/') {
        social = social.slice(0, -1);
    }
    return social
}

export const getSeconds = () => parseInt(new Date().getTime() / 1000)


export const randomString = (length = 30) => [...Array(length)].map(() => Math.random().toString(36)[2]).join('')

export const calculateSum = (array = []) => array.map(r => r.value).reduce((partialSum, a) => partialSum + a, 0);

export const averageArray = (array) => array.reduce((a, b) => a + b) / array.length